<!-- ═══════════════════════════════════════════════════════════════════ -->
<!-- Skeleton Loader                                                     -->
<!-- ═══════════════════════════════════════════════════════════════════ -->
@if (isLoadingUser) {
<div class="dash-main-content">
  <div class="dash-top">
    <h2 class="dash-title">Modifier l'utilisateur</h2>
  </div>
  <div class="edit-skeleton">
    @for (_ of [1, 2, 3]; track _) {
    <div class="skeleton-card">
      <div class="skeleton-line w-40"></div>
      <div class="skeleton-line w-60"></div>
      <div class="skeleton-line w-80"></div>
    </div>
    }
  </div>
</div>
}

<!-- ═══════════════════════════════════════════════════════════════════ -->
<!-- Contenu réel                                                        -->
<!-- ═══════════════════════════════════════════════════════════════════ -->
@if (!isLoadingUser) {
<div class="dash-main-content">
  <!-- Titre + actions -->
  <div class="dash-top">
    <div class="dash-action">
      <div class="dash-action-left">
        <h2 class="dash-title" style="margin: 0;">
          Modifier :
          {{
          (userData?.firstName && userData?.lastName)
          ? (userData.firstName + ' ' + userData.lastName)
          : (userData?.username || 'Utilisateur')
          }}
        </h2>
      </div>
      <div class="dash-action-right">
        <button type="button" class="button neutral icon medium" (click)="onCancel()" [disabled]="isLoading">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 12H4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path d="M10 18L4 12L10 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <span>Annuler</span>
        </button>
        <button type="button" class="button primary icon medium" (click)="onSubmit()"
          [disabled]="isLoading || userForm.invalid || !userForm.dirty">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 21H5C4.47 21 3.96 20.79 3.59 20.41C3.21 20.04 3 19.53 3 19V5C3 4.47 3.21 3.96 3.59 3.59C3.96 3.21 4.47 3 5 3H16L21 8V19C21 19.53 20.79 20.04 20.41 20.41C20.04 20.79 19.53 21 19 21Z"
              stroke="white" stroke-width="1.5" stroke-linejoin="round" />
            <path d="M12 11V15" stroke="white" stroke-width="1.5" stroke-linecap="round" />
            <path d="M9 14H15" stroke="white" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          <span>{{ isLoading ? 'Enregistrement...' : 'Enregistrer' }}</span>
        </button>
      </div>
    </div>
  </div>
  <!-- Formulaire -->
  <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
    <!-- ═══════════════════════════════════════════════════════════════ -->
    <!-- Section 1 : Informations personnelles                          -->
    <!-- ═══════════════════════════════════════════════════════════════ -->
    <div class="accordion-item" [class.active]="basicInfoExpanded">
      <button class="accordion" type="button" (click)="basicInfoExpanded = !basicInfoExpanded">
        <div class="accordion-elements">
          <div class="accordion-left df-center-8">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="8" r="4" stroke="#45B56F" stroke-width="1.5" />
              <path d="M4 21C4 17.6863 7.58172 15 12 15C16.4183 15 20 17.6863 20 21" stroke="#45B56F" stroke-width="1.5"
                stroke-linecap="round" />
            </svg>
            <span>Informations personnelles</span>
          </div>
          <div class="accordion-right">
            <span>{{ basicInfoExpanded ? '▼' : '▶' }}</span>
          </div>
        </div>
      </button>
      <div class="panel" [style.display]="basicInfoExpanded ? 'block' : 'none'">
        <div class="card">
          <div class="form-groups">
            <!-- Username (toujours désactivé) -->
            <div class="field-wrapper">
              <label for="username">
                Nom d'utilisateur
                <span class="lock-hint">🔒 Non modifiable</span>
              </label>
              <input id="username" type="text" class="field" formControlName="username">
            </div>
            <!-- Email (désactivé si vérifié) -->
            <div class="field-wrapper">
              <label for="email">
                Adresse email
                @if (userForm.get('emailVerified')?.value) {
                <span class="lock-hint">
                  🔒 Email vérifié
                </span>
                }
              </label>
              <input id="email" type="email" class="field" formControlName="email"
                [class.error]="!userForm.get('emailVerified')?.value && isFieldInvalid('email')" />
              @if (!userForm.get('emailVerified')?.value
              && userForm.get('email')?.touched
              && userForm.get('email')?.invalid) {
              <div class="error-message">
                @if (hasError('email', 'required')) {
                <span>L'email est requis</span>
                }
                @if (hasError('email', 'email')) {
                <span>Format d'email invalide</span>
                }
              </div>
              }
            </div>
            <!-- Prénom -->
            <div class="field-wrapper">
              <label for="firstName">Prénom *</label>
              <input id="firstName" type="text" class="field" formControlName="firstName"
                [class.error]="isFieldInvalid('firstName')" />
              @if (hasError('firstName', 'required') && userForm.get('firstName')?.touched) {
              <div class="error-message">
                Le prénom est requis
              </div>
              }
            </div>
            <!-- Nom -->
            <div class="field-wrapper">
              <label for="lastName">Nom *</label>
              <input id="lastName" type="text" class="field" formControlName="lastName"
                [class.error]="isFieldInvalid('lastName')" />
              @if (hasError('lastName', 'required') && userForm.get('lastName')?.touched) {
              <div class="error-message">
                Le nom est requis
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ═══════════════════════════════════════════════════════════════ -->
    <!-- Section 2 : Affectation IES / Établissements                   -->
    <!-- ═══════════════════════════════════════════════════════════════ -->
    <div class="accordion-item" [class.active]="assignmentExpanded">
      <button class="accordion" type="button" (click)="assignmentExpanded = !assignmentExpanded">
        <div class="accordion-elements">
          <div class="accordion-left df-center-8">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 21H21" stroke="#45B56F" stroke-width="1.5" stroke-linecap="round" />
              <path d="M5 21V7L12 3L19 7V21" stroke="#45B56F" stroke-width="1.5" stroke-linejoin="round" />
              <path d="M9 9H9.01M9 12H9.01M9 15H9.01M15 9H15.01M15 12H15.01M15 15H15.01" stroke="#45B56F"
                stroke-width="2" stroke-linecap="round" />
            </svg>
            <span>Affectation IES / Établissements</span>
          </div>
          <div class="accordion-right">
            <span>{{ assignmentExpanded ? '▼' : '▶' }}</span>
          </div>
        </div>
      </button>
      <div class="panel" [style.display]="assignmentExpanded ? 'block' : 'none'">
        <div class="card">
          <div class="form-groups">
            <!-- ─── IES ─── -->
            <div class="field-wrapper">
              <label>
                Sigle de l'IES
                @if (isLoadingIes) {
                <span class="loading-hint">Chargement…</span>
                }
              </label>
              <!-- Cas IES_ADMIN connecté : champ désactivé, pré-rempli -->
              @if (isCurrentUserIesAdmin) {
              <input type="text" class="field" [value]="userForm.get('sigleIes')?.value || ''" disabled />
              }
              <!-- Cas SUPER_ADMIN : multi-select searchable -->
              @if (!isCurrentUserIesAdmin) {
              <div id="ies-multiselect" class="custom-multiselect" [class.open]="isIesDropdownOpen"
                [class.disabled]="isLoadingIes">
                <div class="multiselect-trigger field" (click)="!isLoadingIes && toggleIesDropdown()">
                  <span class="selected-values" [class.placeholder]="!userForm.get('sigleIes')?.value">
                    {{
                    isLoadingIes
                    ? 'Chargement...'
                    : (userForm.get('sigleIes')?.value || 'Sélectionnez une IES')
                    }}
                  </span>
                  @if (isLoadingIes) {
                  <span class="spinner" aria-label="Chargement"></span>
                  } @else if (userForm.get('sigleIes')?.value) {
                  <button type="button" class="clear-btn" title="Retirer l'IES (user sans IES)"
                    aria-label="Retirer l'IES" (click)="clearIes(); $event.stopPropagation()">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                      stroke-linecap="round" stroke-linejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                  }
                  <span class="dropdown-arrow">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                      stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </span>
                </div>
                @if (isIesDropdownOpen) {
                <div class="multiselect-dropdown">
                  <div class="dropdown-search">
                    <input type="text" class="field search-input" placeholder="Rechercher une IES..."
                      [formControl]="iesSearchControl" (click)="$event.stopPropagation()" />
                  </div>
                  <div class="dropdown-options">
                    @for (ies of filteredIesList; track ies) {
                    <label class="option-item">
                      <input type="radio" [name]="'ies-radio'" [value]="ies.sigle"
                        [checked]="userForm.get('sigleIes')?.value === ies.sigle" (change)="selectIes(ies.sigle)" />
                      <span>{{ ies.label }}</span>
                    </label>
                    }
                    @if (filteredIesList.length === 0) {
                    <div class="no-options">Aucune IES trouvée</div>
                    }
                  </div>
                </div>
                }
              </div>
              }
            </div>
            <!-- ─── Établissements ─── -->
            <div class="field-wrapper">
              <label>
                Établissements
                @if (isLoadingEtab) {
                <span class="loading-hint">Chargement…</span>
                }
              </label>
              <div id="etab-multiselect" class="custom-multiselect" [class.open]="isEtabDropdownOpen"
                [class.disabled]="isLoadingEtab || !userForm.get('sigleIes')?.value">
                <div class="multiselect-trigger field"
                  (click)="userForm.get('sigleIes')?.value && !isLoadingEtab && toggleEtabDropdown()">
                  <span class="selected-values"
                    [class.placeholder]="(userForm.get('sigleEtablissements')?.value || []).length === 0">
                    {{
                    isLoadingEtab
                    ? 'Chargement...'
                    : ((userForm.get('sigleEtablissements')?.value || []).join(', ')
                    || 'Choisir établissement(s)')
                    }}
                  </span>
                  @if (isLoadingEtab) {
                  <span class="spinner" aria-label="Chargement"></span>
                  }
                  <span class="dropdown-arrow">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                      stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </span>
                </div>
                @if (isEtabDropdownOpen) {
                <div class="multiselect-dropdown">
                  <div class="dropdown-search">
                    <input type="text" class="field search-input" placeholder="Rechercher un établissement..."
                      [formControl]="etabSearchControl" (click)="$event.stopPropagation()" />
                  </div>
                  <div class="dropdown-options">
                    @for (etab of filteredEtabList; track etab) {
                    <label class="option-item">
                      <input type="checkbox" [value]="etab.sigle" [checked]="isEtabSelected(etab.sigle)"
                        (change)="toggleEtabSelection(etab.sigle, $event)" />
                      <span>{{ etab.label }}</span>
                    </label>
                    }
                    @if (filteredEtabList.length === 0) {
                    <div class="no-options">
                      Aucun établissement trouvé
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ═══════════════════════════════════════════════════════════════ -->
    <!-- Section 3 : Configuration globale                              -->
    <!-- ═══════════════════════════════════════════════════════════════ -->
    <div class="accordion-item" [class.active]="configExpanded">
      <button class="accordion" type="button" (click)="configExpanded = !configExpanded">
        <div class="accordion-elements">
          <div class="accordion-left df-center-8">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="3" stroke="#45B56F" stroke-width="1.5" />
              <path
                d="M19.4 15C19.13 15.62 19.26 16.34 19.73 16.82L19.79 16.88C20.17 17.26 20.38 17.76 20.38 18.29C20.38 18.82 20.17 19.33 19.79 19.71C19.41 20.08 18.91 20.29 18.38 20.29C17.85 20.29 17.34 20.08 16.96 19.71L16.9 19.65C16.42 19.18 15.7 19.05 15.08 19.32C14.48 19.58 14.08 20.18 14.08 20.84V21C14.08 22.06 13.22 22.92 12.16 22.92C11.1 22.92 10.24 22.06 10.24 21V20.91C10.23 20.23 9.81 19.63 9.18 19.37C8.57 19.1 7.85 19.23 7.36 19.7L7.3 19.76C6.93 20.14 6.42 20.35 5.89 20.35C5.36 20.35 4.85 20.14 4.48 19.76C4.1 19.39 3.89 18.88 3.89 18.35C3.89 17.82 4.1 17.31 4.48 16.94L4.54 16.88C5.01 16.39 5.14 15.67 4.87 15.06C4.6 14.45 4 14.06 3.34 14.06H3.18C2.12 14.06 1.26 13.2 1.26 12.14C1.26 11.07 2.12 10.21 3.18 10.21H3.27C3.95 10.2 4.55 9.78 4.81 9.16C5.08 8.54 4.95 7.82 4.48 7.34L4.42 7.28C4.04 6.9 3.83 6.39 3.83 5.86C3.83 5.33 4.04 4.83 4.42 4.45C4.79 4.07 5.3 3.86 5.83 3.86C6.36 3.86 6.87 4.07 7.24 4.45L7.3 4.51C7.79 4.98 8.51 5.11 9.12 4.84H9.18C9.79 4.57 10.18 3.98 10.18 3.32V3.18C10.18 2.12 11.04 1.26 12.11 1.26C13.17 1.26 14.03 2.12 14.03 3.18V3.27C14.03 3.93 14.42 4.53 15.03 4.79C15.64 5.07 16.36 4.93 16.85 4.46L16.91 4.4C17.28 4.03 17.79 3.82 18.32 3.82C18.85 3.82 19.36 4.03 19.73 4.4C20.11 4.78 20.32 5.29 20.32 5.82C20.32 6.35 20.11 6.86 19.73 7.23L19.67 7.29C19.2 7.77 19.07 8.49 19.34 9.11V9.17C19.61 9.78 20.21 10.17 20.87 10.17H21C22.06 10.17 22.92 11.03 22.92 12.09C22.92 13.15 22.06 14.01 21 14.01H20.91C20.25 14.01 19.65 14.41 19.39 15.01L19.4 15Z"
                stroke="#45B56F" stroke-width="1.5" />
            </svg>
            <span>Configuration globale</span>
          </div>
          <div class="accordion-right">
            <span>{{ configExpanded ? '▼' : '▶' }}</span>
          </div>
        </div>
      </button>
      <div class="panel" [style.display]="configExpanded ? 'block' : 'none'">
        <div class="card">
          <div class="config-grid">
            <!-- Statut du compte -->
            <div class="config-item">
              <div class="config-item-info">
                <span class="config-item-title">Statut du compte</span>
                <span class="config-item-subtitle">Activer ou désactiver l'accès</span>
              </div>
              <div class="config-item-control">
                <label class="switch">
                  <input type="checkbox" formControlName="isActive" />
                  <span class="slider round"></span>
                </label>
                <span class="status-text">
                  {{ userForm.get('isActive')?.value ? 'Activé' : 'Désactivé' }}
                </span>
              </div>
            </div>
            <!-- Vérification email (lecture seule) -->
            <div class="config-item">
              <div class="config-item-info">
                <span class="config-item-title">Vérification email</span>
                <span class="config-item-subtitle">Statut de la vérification</span>
              </div>
              <div class="config-item-control">
                <div [class]="userForm.get('emailVerified')?.value ? 'badge success' : 'badge danger'">
                  {{ userForm.get('emailVerified')?.value ? 'Vérifié' : 'Non vérifié' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
}

<!-- ═══════════════════════════════════════════════════════════════════ -->
<!-- Snackbar                                                            -->
<!-- ═══════════════════════════════════════════════════════════════════ -->
<div class="snackbar" [class.show]="showSnackbar" [class.success-snackbar]="true">
  <div class="snackbar-content">
    <i class="material-icons snackbar-icon">check_circle</i>
    <span class="snackbar-message">{{ snackbarMessage }}</span>
    <button class="snackbar-close" (click)="hideSnackbar()">
      <i class="material-icons">close</i>
    </button>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════ -->
<!-- Modal succès                                                    -->
<!-- ═══════════════════════════════════════════════════════════════ -->
@if (showSuccessModal) {
  <div class="modal-overlay" (click)="onModalClose()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div class="modal-icon success">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 6L9 17l-5-5"/>
          </svg>
        </div>
        <h3>Utilisateur modifié avec succès</h3>
      </div>
      <div class="modal-body">
        <div class="user-info-row">
          <span class="label">Nom d'utilisateur</span>
          <span class="value">{{ userForm.get('username')?.value }}</span>
        </div>
        <div class="user-info-row">
          <span class="label">Nom complet</span>
          <span class="value">
            {{ (userForm.get('firstName')?.value || '') + ' ' + (userForm.get('lastName')?.value || '') }}
          </span>
        </div>
        <div class="user-info-row">
          <span class="label">Email</span>
          <span class="value">{{ userForm.get('email')?.value }}</span>
        </div>
        <div class="user-info-row">
          <span class="label">Statut</span>
          <span class="value">{{ userForm.get('isActive')?.value ? 'Activé' : 'Désactivé' }}</span>
        </div>
        <div class="user-info-row">
          <span class="label">Email vérifié</span>
          <span class="value">{{ userForm.get('emailVerified')?.value ? 'Oui' : 'Non' }}</span>
        </div>
        <div class="user-info-row">
          <span class="label">IES</span>
          <span class="value">{{ userForm.get('sigleIes')?.value || '—' }}</span>
        </div>
        <div class="user-info-row">
          <span class="label">Établissements</span>
          <span class="value">
            {{ (userForm.get('sigleEtablissements')?.value || []).join(', ') || '—' }}
          </span>
        </div>
      </div>
      <div class="modal-actions">
        <button type="button" class="button neutral medium" (click)="onModalClose()">
          <span>Fermer</span>
        </button>
        <button type="button" class="button primary medium" (click)="onModalGoToList()">
          <span>Liste utilisateurs</span>
        </button>
      </div>
    </div>
  </div>
}